export abstract class NgxZendeskWebwidgetConfig {
  public lazyLoad!: boolean;
  public timeOut!: number;
  public injectionTag!: 'head' | 'body' | 'script' | string;
  public abstract accountUrl: string;
  public abstract callback(zE: any): any;
}
